export default __webpack_public_path__ + "locales/sr-Latn-RS/Settings.json?hash=6c1e6fb44caec72d24def05adf4ad77f";